import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router-dom";
import AppNavbar from "./AppNavbar";
import AppSidebar from "./AppSidebar";
import Footer from "../components/Footer";
import WhatsAppButton from "../common/WhatsAppButton";
import CookieBanner from "../common/CookieBanner";

const titlePrefix = "Dr. Gianfranco Mattina - ";

export default function AppLayout() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <main className="app-root">
      <Helmet titleTemplate={`${titlePrefix}%s`}></Helmet>
      
      <AppNavbar showSidebar={handleShow} />
      <AppSidebar show={show} handleClose={handleClose} />
      
      <div className="app-content">
        <Outlet />
      </div>

      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </main>
  );
}
